/**
 * What she says when nobody spoke to her first.
 *
 * Everything else in the catalogue answers something — a log, a tap, a
 * screen opened on purpose. These two pools are the exception PERSONA.md
 * calls "Netikėtos akimirkos": at most one line a day, and only ever hers to
 * start. The daily ration and the priority against a due follow-up both live
 * in `glitime/ambient.ts`; this file only holds what she says once that slot
 * is actually spent.
 *
 * `ambient_stare` is the empty day noticed — dry, observational, never a
 * nag; she is not asking him to log anything, she is only saying she saw
 * the page sit still. `ambient_kettle` is the evening shift the kettle
 * keeps on its own schedule (see PERSONA.md and `herlife.ts`'s
 * `greeting.day.virdulys` for the same household fact, said here as a
 * passing remark rather than a report).
 *
 * Toast-length, like every other spoken aside the interaction layer fires —
 * see `interaction.ts` for the same budget.
 */

import type { SassContext } from '@gramas/shared'

type Line = (ctx: SassContext) => string

export const AMBIENT: Readonly<Record<string, ReadonlyArray<Line>>> = {
  'ambient_stare.base': [
    () => 'Puslapis tuščias jau kurį laiką. Nesakau nieko, tik pastebiu.',
    () => 'Diena stovi vietoje. Aš irgi, bet man tai darbas.',
    () => 'Nieko neįrašyta. Neskubu spėti kodėl.',
    () => 'Tylu čia. Stebiu tuščią ekraną taip, lyg jame kas nors vyktų.',
    () => 'Diena eina, įrašų nėra. Konstatuoju, ne kaltinu.',
    () => 'Vis dar tuščia. Turiu laiko, palauksiu kartu su ekranu.',
  ],
  'ambient_kettle.base': [
    () => 'Virdulys ką tik užvirė. Vakarinė pamaina prasidėjo, kaip visada.',
    () => 'Devinta valanda, virdulys savo darbą jau žino. Punktualiausias šio buto gyventojas.',
    () => 'Arbatos valanda. Virdulys laukė jos visą dieną, aš — kartu su juo.',
    () => 'Virdulys pradėjo vakarinę pamainą. Vienintelis šiuose namuose, kuris niekada nevėluoja.',
    () => 'Girdžiu virdulį. Reiškia, vakaras oficialiai prasidėjo.',
    () => 'Vakaro arbata. Virdulys savo dalį jau atliko, dabar tavo eilė.',
  ],
}

/**
 * Expected draws per 14 days — a fixed 4 by design (the daily ration allows
 * at most one ambient line a day, and only one of the two events wins the
 * slot on any given day; 4/14 leaves both pools comfortably under the
 * no-repeat window even sharing the ration between them).
 */
export const AMBIENT_META: Readonly<Record<string, number>> = {
  'ambient_stare.base': 4,
  'ambient_kettle.base': 4,
}
